import forEach from "./../util/for-each.js";
import * as respawn from "../respawn.js";

function combineScores(scores1, scores2) {
    var res = {};
    forEach(scores1, (score,id) => {
        res[id] = score;
        if (scores2[id] !== undefined) {
            res[id] += scores2[id];
        }
    });
    forEach(scores2, (score,id) => {
        if (scores1[id] === undefined) {
            res[id] = scores2[id];
        }
    });
    return res;
}

function calculateRoundScore(gameState, time) {
    // A Respawn round scores crashes made and time alive, not who outlived whom
    if (gameState.respawn) {
        return respawn.roundScore(gameState, time);
    }
    var res = {};
    gameState.players.forEach(function (player) {
        res[player.id] = -1;
    });
    var nextScore = 0;
    gameState.gameEvents.forEach(function (gameEvent) {
        if (time !== undefined && gameEvent.time > time) {
            return;
        }
        if (gameEvent.type === "player_died") {
            res[gameEvent.playerId] = nextScore;
            nextScore++;
        }
    });
    forEach(res, function(score, id) {
        if (score === -1) {
            res[id] = nextScore;
        }
    });
    return res;
}

function getStartScore(players) {
    var res = {};
    players.forEach(function (player) {
        res[player.id] = 0;
    });
    return res;
}

// The "first to" target that makes a match of n players run about 6 rounds.
// A round pays the last survivor n-1, the next n-2, ... the first out 0, so
// the average player earns (n-1)/2 a round, and the LEADER (whose score ends
// the match) runs well ahead of that. The factor is MEASURED, not derived:
// full rounds were simulated for every box roster (3 to 25 players on their
// real maps) and matches replayed from them. 4.7 ran 7.3 rounds on average
// (7.7 in the small boxes, 6.7 in the big ones) and felt a round too long
// before the rank moves; 4.2 runs 6.3, and every box lands between 5.9 and 6.7.
// Exact below 50, where a nearest-5 target is far too coarse (in a Duel of 3
// the difference between "first to 10" and "first to 5" is four rounds); the
// nearest 5 from there on (2 -> 5, 4 -> 13, 5 -> 17, 8 -> 29, 10 -> 38,
// 15 -> 60, 20 -> 80, 25 -> 100). Never below 5.
function targetScoreFor(playerCount) {
    var n = Math.max(1, Math.floor(playerCount || 0));
    var raw = 4.2 * (n - 1);
    var step = raw >= 50 ? 5 : 1;
    return Math.max(5, Math.round(raw / step) * step);
}

function getHighestScore(scores) {
    var res = 0;
    forEach(scores, function(score) {
        res = Math.max(res, score);
    });
    return res;
}

function createSortedList(scores) {
    var res = [];
    forEach(scores, function(score, id) {
        res.push({ score, id })
    });
    res.sort((p1, p2) => p2.score - p1.score);
    return res;
}

export {
    combineScores,
    calculateRoundScore,
    getStartScore,
    getHighestScore,
    targetScoreFor,
    createSortedList
};
